<template>
  <AppTable
    :table-data="tableData"
    :loading="loading"
    :lazy-loading="lazyLoading"
    class="widget-common"
    @sort="sort"
  >
    <AppTableColumn
      v-slot="{ row }"
      header="Member"
      name="full_name"
      :sort-by="buildSortOptions('full_name')"
    >
      <div class="d-flex align-items-center">
        <AppAvatar
          size="speck"
          :avatar="row.avatar"
        />
        <div class="ellipsis">
          <a
            v-tooltip
            :title="`View ${row.full_name}'s output`"
            :href="memberUrl(row)"
            class="cursor-pointer"
            @click="handleMemberClick(row, $event)"
          >{{ row.full_name }}</a>
          <div
            v-if="isMembersTimeZoneMode"
            class="ellipsis z-text-gray-500"
          >
            {{ row.time_zone.display_name }} ({{ row.time_zone.offset }})
          </div>
        </div>
      </div>
    </AppTableColumn>
    <AppTableColumn
      v-slot="{ row }"
      header="Merged PRs"
      name="prs"
      :sort-by="buildSortOptions('prs')"
    >
      <div class="d-flex">
        <span class="mr-5">{{ row.prs }}</span>
        <InsightsMetric
          v-show="showMetrics"
          type="number"
          :value="row.prs_delta"
        />
      </div>
    </AppTableColumn>
    <AppTableColumn
      v-slot="{ row }"
      header="Reviews"
      name="reviews"
      :sort-by="buildSortOptions('reviews')"
    >
      <div class="d-flex">
        <span class="mr-5">{{ row.reviews }}</span>
        <InsightsMetric
          v-show="showMetrics"
          type="number"
          :value="row.reviews_delta"
        />
      </div>
    </AppTableColumn>
    <AppTableColumn
      v-slot="{ row }"
      header="Comments"
      name="comments"
      :sort-by="buildSortOptions('comments')"
    >
      <div class="d-flex">
        <span class="mr-5">{{ row.comments }}</span>
        <InsightsMetric
          v-show="showMetrics"
          type="number"
          :value="row.comments_delta"
        />
      </div>
    </AppTableColumn>
  </AppTable>
</template>

<script>
import { mapGetters } from 'vuex';
import InsightsMetric from '~/components/insights/InsightsMetric.vue';
import { isModifierClick } from '~/utils/insights_utils';

export default {
  components: {
    InsightsMetric,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    showMetrics: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    lazyLoading: {
      type: Boolean,
      default: false,
    },
    sortOptions: {
      type: Object,
      required: true,
    },
  },
  emits: ['sort', 'member-selected'],
  computed: {
    ...mapGetters(['isMembersTimeZoneMode']),
  },
  methods: {
    memberUrl(row) {
      const url = new URL(window.location.href);

      url.searchParams.set('tab', 'output');
      url.searchParams.set('user_id', row.id);
      url.searchParams.set('time_zone', row.time_zone.for);
      url.searchParams.set('time_zone_mode', 'user');
      url.searchParams.delete('team_id');

      return url.toString();
    },
    handleMemberClick(row, event) {
      if (isModifierClick(event)) {
        return; // let the browser open in new tab/window as normal
      }
      event.preventDefault();
      this.$emit('member-selected', row);
    },
    sort(options) {
      this.$emit('sort', options);
    },
    buildSortOptions(field) {
      return {
        field,
        direction: this.sortOptions.field === field ? this.sortOptions.direction : null,
      };
    },
  },
};
</script>
